import React, { useState, useCallback } from 'react'
import { useForm } from 'react-hook-form'
import AuthLayout from '../../components/layouts/auth_layout'
import FlatButton from '../../components/buttons/flat_button'
import {
  getKyousouApiClient,
  ApiErrorResponse,
  handleError,
} from '../../services/network'
import { useSnackBar } from '../../providers/snack_bar_provider'
import MainBackground from '../../images/main_bg.png'
import { useNavigate } from 'react-router-dom'
import { useLoading } from '../../providers/loading_provider'

interface RegisterMailFormData {
  email: string
}

const RegisterMailSendPage: React.FC = () => {
  const kyousouApiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()
  const { showLoading, hideLoading } = useLoading()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RegisterMailFormData>()

  const registerMail = useCallback(async (email: string): Promise<void> => {
    showLoading()
    setIsSubmitting(true)
    await kyousouApiClient.enterprise
      .registerMailCreate({ email })
      .then(() => {
        navigate('/register/mail/send/complete')
      })
      .catch((e: ApiErrorResponse) => {
        handleError(e, showSnackBar)
      })
      .finally(() => {
        setIsSubmitting(false)
        hideLoading()
      })
  }, [])

  const onSubmit = async (data: RegisterMailFormData) => {
    await registerMail(data.email)
  }

  return (
    <AuthLayout>
      <div
        className="min-h-screen flex flex-col justify-center items-center bg-cover bg-center bg-no-repeat p-4"
        style={{
          backgroundImage: `url(${MainBackground})`,
        }}
      >
        <div className="bg-white rounded-xl py-8 px-8 w-full max-w-md">
          <h1 className="text-2xl font-bold text-center mb-6">会員登録</h1>
          <p className="mb-2">登録するメールアドレスをご入力ください。</p>
          <p className="mb-6">確認用メールを送信します。</p>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div>
              {errors.email && (
                <p className="text-main-red text-sm mb-1">
                  {errors.email.message}
                </p>
              )}
              <input
                type="email"
                placeholder="メールアドレス"
                {...register('email', {
                  required: 'メールアドレスは必須です',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: '有効なメールアドレスを入力してください',
                  },
                })}
                className="w-full py-2 px-4 border border-black rounded-md outline-none"
              />
            </div>

            <FlatButton type="submit" className="w-full">
              {isSubmitting ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                  送信中...
                </div>
              ) : (
                '送信'
              )}
            </FlatButton>
          </form>
        </div>
      </div>
    </AuthLayout>
  )
}

export default RegisterMailSendPage
